import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class UsersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_list: [],
      data_base: [],
      data_groups: [],
      user_companies: [],
      name: '',
      email: '',
      id: '',
      sigtrip: 0,
      sigrfms: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.editBases = this.editBases.bind(this);
    this.editGroups = this.editGroups.bind(this);
    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
    this.addCompany = this.addCompany.bind(this);
    this.deleteCompany = this.deleteCompany.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleCheckboxChangeBase (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_base).map(function(k) {
      if(self.state.data_base[k].id === name) {
        change = {
          checked: event.target.checked,
          base: self.state.data_base[k].base,
          id: self.state.data_base[k].id,
        };

      } else {
        change = {
          checked: self.state.data_base[k].checked,
          base: self.state.data_base[k].base,
          id: self.state.data_base[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_base: data_temp});
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // Handlers
  handleCheckboxChangeGroups (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.data_groups).map(function(k) {
      if(self.state.data_groups[k].id === name) {
        change = {
          checked: event.target.checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };

      } else {
        change = {
          checked: self.state.data_groups[k].checked,
          group: self.state.data_groups[k].group,
          id: self.state.data_groups[k].id,
        };
      }
      data_temp.push(change);
    });
    this.setState({data_groups: data_temp});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/usuario/bases/relacionadas/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_base: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/usuario/grupos/permissao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/usuario/editar/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            email: responseJson.data.main.email,
            staff_id: responseJson.data.main.staff_id,
            sigtrip: responseJson.data.main.sigtrip,
            sigrfms: responseJson.data.main.sigrfms,
            companies_select: responseJson.data.companies_select,
            user_companies: responseJson.data.user_companies,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Grupos de permissão */ }); /* Lista de funcionários */ }); /* Dados do usuário */
    });
  }

  // Fetch salvando a edição
  editBases(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      data: this.state.data_base,
      user_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/bases/relacionadas', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_base: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  editGroups(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      data: this.state.data_groups,
      user_id: this.props.match.params.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/grupos/permissao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_groups: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      sigtrip: this.state.sigtrip,
      sigrfms: this.state.sigrfms,
      email: this.state.email,
      staff_id: this.state.staff_id,
      name: this.state.name,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            staff_name: responseJson.data.staff_name,
            staff_id: responseJson.data.staff_id,
            email: responseJson.data.email,
            sigtrip: responseJson.data.sigtrip,
            sigrfms: responseJson.data.sigrfms,
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

      // Fetch salvando a edição
    addCompany(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        user_id: this.state.id,
        company_id: this.state.company_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/usuario/empresa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ loaded: 1 });
          self.setState({user_companies: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição
    deleteCompany(id) {
      if (window.confirm(this.locale.Usuarios.EditarUsuario.deletarEmpresa)) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/usuario/empresa/' + id, { method: 'DELETE', mode: 'cors', headers: value, }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ loaded: 1 });
            self.setState({user_companies: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }



  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Usuarios.EditarUsuario.titulo}</h3>
      <Link to="/usuarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Usuarios.EditarUsuario.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Usuarios.EditarUsuario.formulario.Funcionario}:</label>
            <Select
              className=""
              name="staff_id"
              value={this.state.staff_id}
              searchable={true}
              placeholder={this.locale.Usuarios.EditarUsuario.formulario.placeholder.SelecionarFuncionario}
              onChange={this.handleSelectChange.bind(this, 'staff_id')}
              options={this.state.staff_list}
            />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.Usuarios.EditarUsuario.formulario.UsadoEmSigtrip}?</label>
              <br/>
              <Toggle
                checked={this.state.sigtrip}
                aria-label='No label tag'
                name="sigtrip"
                onChange={this.handleToggleChange.bind(this, 'sigtrip')} />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.Usuarios.EditarUsuario.formulario.UsadoEmSigrfms}?</label>
              <br/>
              <Toggle
                checked={this.state.sigrfms}
                aria-label='No label tag'
                name="sigrfms"
                onChange={this.handleToggleChange.bind(this, 'sigrfms')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Usuarios.EditarUsuario.botaoSalvar}</button>
          </div>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.Usuarios.EditarUsuario.tituloGruposDePermissoes}</h3>
      <hr/>
      <form onSubmit={this.editGroups}>
        <div className="row">
          {Object.keys(self.state.data_groups).map(function(k) {
            return (
              <div className="col-md-3 col-md-offset-1">
                <div className="form-group">
                  <label>
                    <input
                      name="checkbox"
                      label={self.state.data_groups[k].group}
                      type="checkbox"
                      checked={self.state.data_groups[k].checked}
                      onChange={self.handleCheckboxChangeGroups.bind(self, self.state.data_groups[k].id)} />
                    {self.state.data_groups[k].group}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Usuarios.EditarUsuario.botaoSalvarGrupos}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default UsersEdit;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersEdit.js